import React from 'react';
export function TopBanner() {
  return <div className="bg-orange-50 text-orange-800 py-2 px-4 text-center text-sm font-medium border-b border-orange-100" data-id="element-100">
      <span className="flex items-center justify-center gap-2" data-id="element-101">
        <span className="relative flex h-2 w-2" data-id="element-102">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75" data-id="element-103"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-orange-500" data-id="element-104"></span>
        </span>
        Limited availability in your area
      </span>
    </div>;
}